// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__23k1_","buttons":"RemoveExpirationActionButtons_buttons__ZiHx5"};